import type { IntlShape } from 'react-intl'

import { createRoutes } from '../../routes'

export function getAgentFAQ(intl: IntlShape) {
  const routes = createRoutes(intl.locale)
  return [
    {
      question: intl.formatMessage({
        id: 'agent.faq.question1',
        defaultMessage: 'What is Slite Agent?',
      }),
      answer: intl.formatMessage({
        id: 'agent.faq.answer1',
        defaultMessage:
          'Slite Agent is the AI agent built into Slite, your team knowledge base. It has two jobs: keeping your knowledge base true, and finding answers from it. It watches your connected tools (Slack, Linear, GitHub, Intercom and 20+ more), detects when docs have drifted from reality, and drafts the fix — updating docs, writing new ones, or merging duplicates. Every change goes through human approval before anything goes live: the agent proposes, you approve.',
      }),
    },
    {
      question: intl.formatMessage({
        id: 'agent.faq.question2',
        defaultMessage: 'Is Slite Agent a knowledge base agent?',
      }),
      answer: intl.formatMessage({
        id: 'agent.faq.answer2',
        defaultMessage:
          'Yes — Slite Agent is purpose-built for your knowledge base. Unlike generic AI assistants bolted onto a wiki, it maintains the knowledge base itself: it monitors your connected tools for changes, flags docs that have gone stale or contradict each other, proposes fixes for a human to review, and answers questions with cited, permission-aware sources. Verified docs rank first, and every answer shows where it came from.',
      }),
    },
    {
      question: intl.formatMessage({
        id: 'agent.faq.question3',
        defaultMessage: 'Can other AI agents use Slite as a knowledge source?',
      }),
      answer: intl.formatMessage(
        {
          id: 'agent.faq.answer3',
          defaultMessage:
            'Yes. The <link>Slite MCP server</link> connects any MCP-compatible AI — Claude, ChatGPT, Cursor, Gemini, or your own custom agents — to your knowledge base with a single OAuth connection. Agents can search across Slite and all your connected sources, read full docs, and even propose changes that go through the same human approval as Slite Agent itself. Access always mirrors the permissions of the signed-in user. For custom integrations, there is also a REST API.',
        },
        {
          link: (chunks) => (
            <a href={routes.mcp()} className="underline saturn-orange">
              {chunks}
            </a>
          ),
        }
      ),
    },
  ]
}
